import { render, staticRenderFns } from "./handles.vue?vue&type=template&id=4189805d&scoped=true&"
import script from "./handles.vue?vue&type=script&lang=js&"
export * from "./handles.vue?vue&type=script&lang=js&"
import style0 from "./handles.vue?vue&type=style&index=0&id=4189805d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4189805d",
  null
  
)

export default component.exports